<template>
  <div class="position-relative">
    <template v-if="!hidden">
      <vue-perfect-scrollbar
        :settings="{
          maxScrollbarLength: 60,
          wheelPropagation: false,
        }"
        class="scroll-area"
        tagname="div"
      >
        <ul class="ul-options m-0">
          <li
            v-for="(menu, index) in menus"
            :key="index"
          >
            <pay-box-tef-actions
              v-if="payBoxActionsEnum.TEF == menu.type"
              is-dark
            />
            <b-button
              v-else
              :id="menu.elId"
              :variant="menu.disabled ? 'dark' : 'outline-dark'"
              class="btn-pdv-operation"
              :class="{ 'disabled-opacity': !menu.hasPermission }"
              :title="menu.text"
              :disabled="menu.disabled"
              @click="() => onVerifyUserPermission(menu.hasPermission, () => menu.clickAction(menu.type))
              "
            >
              <div class="d-flex flex-column align-items-center justify-content-center">
                <b-icon
                  class="mb-1"
                  scale="1.5"
                  :icon="menu.icon"
                />
                {{ menu.text }}
              </div>
            </b-button>
          </li>
        </ul>
      </vue-perfect-scrollbar>
    </template>
  </div>
</template>

<script>
import { BIcon, BButton } from 'bootstrap-vue'
import { app, paymentTypes } from '@/mixins'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { hasErpAccess } from '@/auth/utils'
import { mapGetters } from 'vuex'
import isElectron from 'is-electron'
import PayBoxTefActions from '../pay-box/components/PayBoxTefActions.vue'

export default {
  components: { BIcon, BButton, VuePerfectScrollbar, PayBoxTefActions },

  mixins: [app, paymentTypes],

  props: {
    hidden: {
      type: Boolean,
      required: true,
    },
    isFullScreen: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters('pages/pdv/payBoxConfiguration', ['isTefEnabled']),

    menus() {
      const { TEF } = this.payBoxActionsEnum
      return [
        {
          elId: 'btn_atm_home',
          icon: 'house',
          text: this.$t('ATM home'),
          clickAction: () => {
            this.$router.push({ name: 'pdv-atm' })
          },
          type: '',
          disabled: this.$route.name === 'pdv-atm',
          // hasPermission: this.$can('Setup', 'PayBox'),
          // show: this.$can('Setup', 'PayBox'),
          hasPermission: true,
          show: true,
        },
        {
          elId: 'btn_atm_configuration',
          icon: 'gear',
          text: this.$t('Config. do PDV'),
          clickAction: () => {
            this.$router.push({ name: 'pdv-atm-configuration' })
          },
          type: '',
          disabled: this.$route.name === 'pdv-atm-configuration',
          hasPermission: this.$can('Setup', 'PayBox'),
          show: this.$can('Setup', 'PayBox'),
        },
        {
          type: TEF,
          hasPermission: true,
          show: this.isTefEnabled,
        },
        {
          elId: 'atm_close',
          icon: 'BoxArrowRight',
          text: this.$t('Fechar Caixa'),
          clickAction: () => {
            this.$router.push({ name: 'pdv-pay-box-close' })
          },
          type: '',
          disabled: false,
          hasPermission: true,
          show: true,
        },
        {
          elId: 'atm_fullscreen',
          icon: 'fullscreen',
          text: this.$t('Tela Cheia'),
          clickAction: () => {
            this.toggleFullScreen()
          },
          type: '',
          disabled: false,
          hasPermission: true,
          show: true,
        },
        {
          elId: 'atm_back_erp',
          icon: 'ArrowBarLeft',
          text: this.$t('Voltar ao ERP'),
          clickAction: () => {
            this.$router.push({ name: 'home' })
          },
          type: '',
          disabled: false,
          hasPermission: hasErpAccess(),
          show: hasErpAccess(),
        },
      ].filter(t => t.show)
    },
  },

  methods: {
    onVerifyUserPermission(hasPermission, callback) {
      if (!hasPermission) {
        this.showError({
          title: this.$t('Acesso negado'),
          message: this.$t('Você não possui acesso a esta funcionalidade.'),
        })
        return
      }

      callback()
    },

    async toggleFullScreen() {
      if(!isElectron()) return
      const newFullScreenState = !this.isFullScreen
      await window.electronAPI.system.setFullScreen(newFullScreenState)
      this.$emit('full-screen-changed', newFullScreenState)
    }
  },
}
</script>

<style scoped lang="scss">
.disabled-opacity {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.brand-logo {
  height: 50px;
  width: 50px;
  margin: 0 auto;
}

.hidden-aside {
  position: absolute;
  right: 5px;
  bottom: 15px;
}

.btn-pdv-operation {
  width: 90px;
  height: 90px;
  padding: 10px 10px;
}

.scroll-area {
  position: relative;
  margin: 0;
  // width is col1 + col2 of grid layout
  width: 100% !important;
  height: 90px !important;

  padding: 0px;
}

.ul-options {
  padding: 0px 15px 0px;
  list-style: none;

  display: flex;
  flex-flow: nowrap row;
  align-items: flex-start;
  gap: 20px;
}
</style>
